import logo from './logo.svg';
import './App.css';
import Navigationbar from './Components/NavigationBar/Navigationbar';
import ContentBar from './Components/ContentBar/ContentBar';
import Footer from './Components/Footer/Footer';

import MobileFooter from './Components/MobileFooter/MobileFooter';



function App() {
  return (
    <div className="App">
     <div className='MainLayout'>
      <Navigationbar />
      <ContentBar />
      
    
      
     </div>
      

      
    </div>
  );
}

export default App;
